import React from 'react';
import ThumbIconButton from '@wix/da-ds/pkg/thumbs/ThumbIconButton';
import { useFaveButton } from '../../../../FaveButton/useFaveButton';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
var FaveControl = function (_a) {
    var deviation = _a.deviation, _b = _a.showStatNumbers, showStatNumbers = _b === void 0 ? true : _b, className = _a.className;
    var showStats = useOverlayContext(deviation).showStats;
    var _c = useFaveButton(deviation), isFavourite = _c.isFavourite, faveCount = _c.faveCount, onClick = _c.onClick, biData = _c.biData;
    return (React.createElement(ThumbIconButton, { className: className, type: "fave", isEngaged: isFavourite, showStatValue: showStats && showStatNumbers, statValue: faveCount, onClick: onClick, biData: biData }));
};
FaveControl.displayName = 'FaveControl';
export default FaveControl;
//# sourceMappingURL=FaveControl.js.map